// extracted by mini-css-extract-plugin
module.exports = {"section":"FilterByType-module_section_31JjY","title":"FilterByType-module_title_3kQB3"};